/* alc-stl.js — two-way sync between the hotspot pins on a look and the product
   rail underneath it. Several sections can sit on one page, so the file guards
   against executing twice and marks each look it has already wired up. */
(function () {
  'use strict';

  if (window.__alcStlLoaded) return;
  window.__alcStlLoaded = true;

  var DESKTOP = '(min-width: 990px)';

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll the rail, clamped, with a fallback: some engines quietly ignore
     smooth scrolling on an overflow container, and leaving the card off-screen
     would defeat the whole point of tapping the pin. */
  function scrollRailTo(rail, left) {
    var max = rail.scrollWidth - rail.clientWidth;
    var target = Math.max(0, Math.min(left, max));
    var before = rail.scrollLeft;

    if (Math.abs(target - before) < 2) return;

    if (typeof rail.scrollTo !== 'function') {
      rail.scrollLeft = target;
      return;
    }

    try {
      rail.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
    } catch (e) {
      rail.scrollLeft = target;
      return;
    }

    window.setTimeout(function () {
      if (Math.abs(rail.scrollLeft - before) < 2) rail.scrollLeft = target;
    }, 320);
  }

  function setActive(look, index, options) {
    var opts = options || {};
    var pins = look.querySelectorAll('[data-alcstl-pin]');
    var items = look.querySelectorAll('[data-alcstl-item]');
    var target = null;

    Array.prototype.forEach.call(pins, function (pin) {
      var on = pin.getAttribute('data-alcstl-pin') === index;
      pin.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    Array.prototype.forEach.call(items, function (item) {
      var on = item.getAttribute('data-alcstl-item') === index;
      item.setAttribute('data-active', on ? 'true' : 'false');
      if (on) target = item;
    });

    // Bring the matching card into view — on mobile that is the horizontal
    // rail, which is the whole point of tapping a pin.
    if (target && opts.scrollToItem) {
      var rail = look.querySelector('[data-alcstl-items]');
      if (rail && rail.scrollWidth > rail.clientWidth + 1) {
        // Measured from the rail itself, so it does not depend on which
        // ancestor happens to be the offsetParent.
        var itemRect = target.getBoundingClientRect();
        var railRect = rail.getBoundingClientRect();
        var left =
          rail.scrollLeft + (itemRect.left - railRect.left) - (railRect.width - itemRect.width) / 2;

        scrollRailTo(rail, left);
      }
    }
  }

  function clearActive(look) {
    Array.prototype.forEach.call(look.querySelectorAll('[data-alcstl-pin]'), function (pin) {
      pin.setAttribute('aria-pressed', 'false');
    });
    Array.prototype.forEach.call(look.querySelectorAll('[data-alcstl-item]'), function (item) {
      item.setAttribute('data-active', 'false');
    });
  }

  function wireLook(look) {
    if (look.dataset.alcstlReady === 'true') return;
    look.dataset.alcstlReady = 'true';

    Array.prototype.forEach.call(look.querySelectorAll('[data-alcstl-pin]'), function (pin) {
      var index = pin.getAttribute('data-alcstl-pin');

      pin.addEventListener('click', function () {
        var alreadyOn = pin.getAttribute('aria-pressed') === 'true';
        if (alreadyOn) {
          clearActive(look);
        } else {
          setActive(look, index, { scrollToItem: true });
        }
      });

      pin.addEventListener('mouseenter', function () {
        if (window.matchMedia(DESKTOP).matches) setActive(look, index, {});
      });

      pin.addEventListener('focus', function () {
        setActive(look, index, { scrollToItem: true });
      });
    });

    Array.prototype.forEach.call(look.querySelectorAll('[data-alcstl-item]'), function (item) {
      var index = item.getAttribute('data-alcstl-item');

      item.addEventListener('mouseenter', function () {
        if (window.matchMedia(DESKTOP).matches) setActive(look, index, {});
      });

      item.addEventListener('focus', function () {
        setActive(look, index, {});
      });
    });

    look.addEventListener('mouseleave', function () {
      if (window.matchMedia(DESKTOP).matches) clearActive(look);
    });
  }

  function init(scope) {
    var root = scope || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-alcstl-look]'), wireLook);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
